import { render, staticRenderFns } from "./InputCaptchaPage.vue?vue&type=template&id=16806014"
import script from "./InputCaptchaPage.vue?vue&type=script&lang=js"
export * from "./InputCaptchaPage.vue?vue&type=script&lang=js"
import style0 from "./InputCaptchaPage.vue?vue&type=style&index=0&id=16806014&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports